import { ClubOnboardingSettingsDTO } from "@gymflow/types";
import { useMutationOnboardingSettings } from "libs/api/src/lib/hooks/onboardingSettings/useMutationOnboardingSettings";
import { useQueryOnboardingSettings } from "libs/api/src/lib/hooks/onboardingSettings/useQueryOnboardingSettings";
import { useCallback, useEffect, useState } from "react";

import useGymflowModels from "../../../store";
import { Spinner } from "../../atoms";
import { OnboardingLeftMenu } from "./OnboardingLeftMenu";
import { OnboardingRightMenu } from "./OnboardingRightMenu";

export function OnboardingSettings() {
  const { api } = useGymflowModels();
  const {
    data: onboardingSettings,
    isLoading,
    isSuccess,
  } = useQueryOnboardingSettings({
    api,
  });
  const [localState, _setLocalState] = useState<ClubOnboardingSettingsDTO>();
  useEffect(() => {
    if (onboardingSettings && isSuccess) {
      _setLocalState(onboardingSettings);
    }
  }, [onboardingSettings, isSuccess]);
  const { mutate: updateOnboardingSettings } = useMutationOnboardingSettings({
    api,
  });
  const setLocalState = useCallback(
    (state: ClubOnboardingSettingsDTO) => {
      _setLocalState(state);
      updateOnboardingSettings(state);
    },
    [updateOnboardingSettings],
  );
  return (
    <div className="relative flex size-full">
      <div className="absolute inset-0 flex flex-col gap-4 overflow-auto lg:flex-row">
        {isLoading && <Spinner />}
        {!!localState && (
          <>
            <OnboardingLeftMenu
              localState={localState}
              setLocalState={setLocalState}
            />
            <OnboardingRightMenu
              localState={localState}
              setLocalState={setLocalState}
            />
          </>
        )}
      </div>
    </div>
  );
}
